import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
} from "reactstrap"
import { Link } from "react-router-dom"

import classNames from "classnames"

//import Charts
import StackedColumnChart from "./StackedColumnChart"

//import action
import { getChartsData as onGetChartsData } from "../../store/actions"

// Image
import modalimage1 from "../../assets/images/product/img-7.png"
import modalimage2 from "../../assets/images/product/img-4.png"

// Pages Components
import WelcomeComp from "./WelcomeComp"
import MonthlyEarning from "./MonthlyEarning"
import SocialSource from "./SocialSource"
import ActivityComp from "./ActivityComp"
import TopCities from "./TopCities"
import LatestTranaction from "./LatestTranaction"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

//i18n
import { withTranslation } from "react-i18next"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"

import API_SERVICE from "shared/services/api-services"
import { notification } from "shared/utility/Utility"
import Spinners from "components/Common/Spinner"
const Dashboard = props => {
  const [isLoading, setLoading] = useState(false)
  const [dashboardData, setDashboardData] = useState({})

  const reports = [
    {
      title: "Total # of registrations",
      iconClass: "bx-copy-alt",
      description: `${dashboardData?.totalRegistrations}`,
    },
    {
      title: "# of users",
      iconClass: "bx-archive-in",
      description: `${dashboardData?.totalUsers}`,
    },
  ]

  const getDashboardData = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.getDashboardData()
      setDashboardData(data)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }
  const [dataUser, setData] = useState([])

  const getData = async () => {
    try {
      const {
        data: { data },
      } = await API_SERVICE.fetchSelf()
      setData(data)
    } catch (error) {
      notification("error", API_SERVICE.handleErrors(error))
    }
  }
  useEffect(() => {
    getData()
  }, [])
  useEffect(() => {
    getDashboardData()
  }, [])

  //meta title
  document.title = "Inventya"

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners setLoading={setLoading} />
      ) : (
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */}
            <Breadcrumbs
              title={props.t("Dashboards")}
              breadcrumbItem={props.t("Dashboard")}
            />

            <Row className="justify-content-between">
              <Col xl="4">
                <WelcomeComp
                  name={dataUser?.name}
                  last7={dashboardData?.lastSevenDaysRegistrations}
                  last30={dashboardData?.lastThirtyDaysRegistrations}
                />
              </Col>
              <Col xl="3">
                <Row className="flex-column">
                  {(reports || [])?.map((report, key) => (
                    <Col key={"_col_" + key}>
                      <Card className="mini-stats-wid">
                        <CardBody>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <p className="text-muted fw-medium">
                                {report.title}
                              </p>
                              <h4 className="mb-0">{report.description}</h4>
                            </div>
                            <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                              <span className="avatar-title rounded-circle bg-primary">
                                <i
                                  className={
                                    "bx " + report.iconClass + " font-size-24"
                                  }
                                ></i>
                              </span>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </Col>
              <Col xl="4">
                <TopCities data={dashboardData?.countryWiseRegistrations} />
              </Col>
            </Row>

            <Row>
              <Col lg="12">
                <LatestTranaction
                  isLoading={isLoading}
                  setLoading={setLoading}
                  data={dashboardData?.latestRegistrations}
                />
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Dashboard)
